// PPE 2.0 (DEV-4849): CRUD client for per-economic-component capture-policy rows (CapturePolicyController).
// Every call skips the global forbidden-reload: GETs degrade to seed components, and WRITES surface a 403
// inline via the thunk mutation-error slice instead of triggering the page-reload interceptor.
import { SKIP_FORBIDDEN } from './httpConfig';

export class CapturePolicyApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getRows() {
    return this.#http.get('/api/capture-policy-rows', SKIP_FORBIDDEN);
  }

  async getRow(capturePolicyRowId) {
    return this.#http.get(`/api/capture-policy-rows/${capturePolicyRowId}`, SKIP_FORBIDDEN);
  }

  async createRow(body) {
    return this.#http.post('/api/capture-policy-rows', body, SKIP_FORBIDDEN);
  }

  async updateRow(capturePolicyRowId, body) {
    return this.#http.put(`/api/capture-policy-rows/${capturePolicyRowId}`, body, SKIP_FORBIDDEN);
  }

  async deleteRow(capturePolicyRowId) {
    return this.#http.delete(`/api/capture-policy-rows/${capturePolicyRowId}`, SKIP_FORBIDDEN);
  }
}
